import { Container, Nav } from "react-bootstrap";

export const SCFooter = () => {
  const currentYear = new Date().getFullYear();
  const basePath ="https://www.icohweb.org/site/";
  return (
    <footer className="footer">
      <Container className="py-5">
        <div className="d-md-flex flex-row align-items-center">
          <div className="d-flex justify-content-center">
            <img
              src={`${process.env.REACT_APP_ASSETS_PATH}/images/footer-logo.gif`}
              className="me-3"
              alt="ICOH – International Commission on Occupational Health"
              height={89}
              width={194}
            />
          </div>
          <div>
            <Nav>
              <Nav.Item>
                <Nav.Link href={`${basePath}about-icoh.asp`}>About ICOH</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href={`${basePath}core-documents.asp`}>Core documents</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href={`${basePath}news.asp`}>News</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href={`${basePath}publications.asp`}>Publications</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href={`${basePath}reports.asp`}>Reports</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href={`${basePath}events.asp`}>Events</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href={`${basePath}links.asp`}>Link</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href={`${basePath}contact-us.asp`}>Contact Us</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href={`${basePath}private-area-login.asp`}>Admin</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link href={`${basePath}cookie-policy.asp`}>Cookie policy</Nav.Link>
              </Nav.Item>
            </Nav>
            © Copyright {currentYear} ICOH – International Commission on Occupational Health<br />
            Legal residence: via San Barnaba 8, 20122 Milano, Italy<br />
            Operating office: ICOH / INAIL Research Area, Via Fontana Candida, 1 – 00078 Monte Porzio Catone (RM), Italy
          </div>
        </div>
      
      </Container>
      <Container className="py-4 bg-primary text-light" fluid>
        <Container>
          ICOH is not responsible for contents uploaded on Scientific Committees webpages including: materials, hyperlinks and advertisements. ICOH Scientific Committees assume full responsibility for their own submissions
        </Container>
      </Container>
    </footer>
  );
};
